import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Store } from "../../Store";
import { useNavigate } from "react-router-dom";
import { getError } from "../../Utils/GetErrors";
import ToastIt from "../../components/Toast";

function LoginScreen() {
  // const [email, setEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [password, setPassword] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [showResetForm, setShowResetForm] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [variance, setVariance] = useState("");

  const navigate = useNavigate();

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo, baseUrl } = state;

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(`${baseUrl}/user/login`, {
        userPhone,
        password,
      });
    //   const data = {
    //     balance: 360, 
    //     email: "jerrybabatunde1@gmail.com",
    //     isAdmin: true,
    //     phone: 247792110,
    //     status: "Active",
    //     token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2N2MzYmJjZTc2YjBiYzBiOTcyYmNlNDEiLCJ1c2VybmFtZSI6InN1cGVyamN5YnMiLCJlbWFpbCI6ImplcnJ5YmFiYXR1bmRlMUBnbWFpbC5jb20iLCJpc0FkbWluIjpmYWxzZSwiYmFsYW5jZSI6MzYwLCJpYXQiOjE3NDEyODg4MjAsImV4cCI6MTc0MTM3NTIyMH0.s4C7gNzop8YhD45WA-vViANhkB-BxNi73X_W3HncFdw",
    //     userLevel: "Admin",
    //     username: "superjcybs",
    //     _id: "67c3bbce76b0bc0b972bce41"
    // }
      ctxDispatch({ type: "USER_SIGNIN", payload: data });
      ctxDispatch({ type: "UPDATE_USERDATA", payload: data });
      localStorage.setItem("userInfo", JSON.stringify(data));
      localStorage.setItem("CurrUser", JSON.stringify(data));

      setToastMessage("Login successful");
      setVariance("success");
      setShowToast(true);
      setTimeout(() => {
        navigate("/home");
      }, 2000);
      // ctxDispatch({ type: 'UPDATE_USERDATA', payload: data });
    } catch (err) {
      setToastMessage(getError(err));
      setVariance("danger");
      setShowToast(true);
    }
  };

  const forgetPasswordHandler = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${baseUrl}/user/forget-password`, {
        email: resetEmail,
      });
      setShowToast(true);
      setVariance("success");
      setToastMessage("Password reset email sent. Please check your inbox.");
      setShowResetForm(false);
    } catch (err) {
      setShowToast(true);
      setVariance("danger");
      setToastMessage(getError(err));
    }
  };

  useEffect(() => {
    if (userInfo) {
      navigate("/");
    }
  }, [navigate, userInfo]);

  const formContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    flexDirection: "column",
    background: "url('/images/Key.webp') no-repeat center/cover",
    height: "91vh",
  };

  const formContainer = {
    // width:'25vw',
    border: "1px solid transparent",
    padding: "20px",
    borderRadius: "10px",
    alignItems: "center",
    backgroundColor: "whitesmoke",
  };

  const loginFormStyle = {
    width: "100%",
  };

  return (
    <div style={formContainerStyle}>
      <h2 style={{ textAlign: "center", color: "white" }}>KYEKYEKU TECH</h2>
      {/* <span>
        Don't have an Account? <a href="/register">Register</a>
      </span>
      <hr /> */}
      <div style={{ textAlign: "center", marginBottom: "-25px", backgroundColor:'white', borderRadius:'50%', padding:'10px' }}>
        <img
          src="/images/logoc.png"
          alt="Logo"
          style={{
            width: "90px",
            height: "90px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </div>
      <div style={formContainer} className="col-9 col-lg-3">
        <p className="text-center fw-bold"> LOGIN HERE</p>
        <Form style={loginFormStyle} onSubmit={submitHandler}>
          {/* <Form.Group className="mb-3" controlId="email">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Email must be in lowercase"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group> */}

          <Form.Group className="mb-1" controlId="userPhone">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter phone number"
              maxLength="10"
              pattern="[0-9]*"
              inputMode="numeric"
              onChange={(e) =>
                setUserPhone(e.target.value.replace(/[^0-9]/g, ""))
              }
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter password"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Button variant="primary" className="w-100" type="submit">
            {" "}
            Login
          </Button>
          <Form.Group className="my-3" controlId="formBasicCheckbox">
            <Form.Text
              className=""
              style={{ cursor: "pointer", fontSize: "0.8em", color:"red" }}
              onClick={() => navigate("/register")}
            >
              Create Account
            </Form.Text>
            <Form.Text
              className="clearfix float-end"
              style={{ cursor: "pointer", fontSize: "0.8em" }}
              onClick={() => setShowResetForm(true)}
            >
              Forgot your password?
            </Form.Text>
          </Form.Group>
        </Form>

        {showResetForm && (
          <div className="mt-4">
            <p  className="text-center fw-bold">RESET PASSWORD</p>
            <Form onSubmit={forgetPasswordHandler} className="mb-4">
              <Form.Group className="mb-2">
                {/* <Form.Label htmlFor="resetEmail">Email address</Form.Label> */}
                <Form.Control
                  type="email"
                  placeholder="Enter registerd email"
                  id="resetEmail"
                  required
                  onChange={(e) => setResetEmail(e.target.value)}
                />
              </Form.Group>
              <Button type="submit" variant="success" size="sm">
                {" "}
                Send Reset Email
              </Button>{" "}
              <Button
                type="button"
                variant="danger" size="sm"
                onClick={() => setShowResetForm(false)}
              >
                {" "}
                Cancel{" "}
              </Button>
            </Form>
          </div>
        )}
        <ToastIt
          Variance={variance}
          Message={toastMessage}
          ShowToast={showToast}
          OnClose={() => setShowToast(false)}
        />
      </div>
    </div>
  );
}

export default LoginScreen;
